import { fetcher } from "helpers/fetcher";

import { TCreateTagReq, TCreateTagRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createTag = async (payload: TCreateTagReq) => {
  return await fetcher<TCreateTagRes, TCreateTagReq["data"]>(
    ENDPOINT.MANAGEMENT.CREATE_TAG,
    {
      data: payload.data,
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.CREATE_TAG.version,
      },
    }
  );
};

export const mutationCreateTag = async (payload: TCreateTagReq) => {
  return (await createTag(payload)).data.message;
};

mutationCreateTag._key = (payload: TCreateTagReq) => [
  ENDPOINT.MANAGEMENT.CREATE_TAG.url,
  payload,
];
